export class BoardingPlaceDensityOfPeopleFactor
{
    id:number;
    regionId:number;
    values:BoardingPlaceDensityOfPeopleFactorValue[];
}
export class BoardingPlaceDensityOfPeopleFactorValue
{
    transportModeId:number;
    value:number;
}